import { type EnterprisePolicyResponse } from "@/api";
import { enterprisePolicyPlatformCoverageSeed } from "./seed";
import { enterprisePoliciesStore } from "./store";

type EnterprisePolicyPlatformCoverageRow = {
  platform: string;
  type: string;
  adoptionStatus: string;
  owner: string;
};

export function createEnterprisePolicyUsingPostMock(
  params?: Record<string, unknown>,
): EnterprisePolicyResponse & {
  platformCoverage?: EnterprisePolicyPlatformCoverageRow[];
} {
  const policy = enterprisePoliciesStore.create(params);

  return {
    ...policy,
    platformCoverage: enterprisePolicyPlatformCoverageSeed,
  };
}
